var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "application-career--group" }, [
    _c("div", { staticClass: "tag-sections" }, [
      _c("section", [
        _c("div", { staticClass: "title-container no-left-padding" }, [
          _c(
            "div",
            [
              _c("Title", {
                attrs: {
                  title: _vm.title,
                  editable: false,
                  deletable: true,
                  parent: true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "add-button",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openAddDialog.apply(null, arguments)
                }
              }
            },
            [_c("Icon", { attrs: { icon: "plus" } })],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pl-3" },
          [
            !_vm.section && !_vm.hasItems
              ? _c("div", { staticClass: "mt-3" }, [
                  _vm._v(
                    "\n\t\t\t\t\tEs sind noch keine Einträge vorhanden.\n\t\t\t\t"
                  )
                ])
              : [
                  _vm._l(_vm.grouped, function(group) {
                    return [
                      "sub-sections-title-" + group.title
                        ? _c(
                            "div",
                            {
                              key: group.id,
                              staticClass: "sub-sections-title no-left-padding"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(group.title) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: "sub-sections-" + group.id,
                          staticClass: "career-items"
                        },
                        _vm._l(group.items, function(item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "career-item" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { md: "3" } },
                                        [
                                          item.end
                                            ? [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm._f("dateByObject")(
                                                        item.start,
                                                        "LL/y"
                                                      )
                                                    ) +
                                                    " -\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm._f("dateByObject")(
                                                        item.end,
                                                        "LL/y"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            : item.start
                                            ? [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm._f("dateByObject")(
                                                        item.start,
                                                        "LL/y"
                                                      )
                                                    ) +
                                                    " - aktuell\n\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            : [_vm._v("? - ?")]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { md: "8" } },
                                        [
                                          _vm.education
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "career-item-title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getEducationTitle(
                                                          item
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.schoolType
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "career-item-subtitle"
                                                      },
                                                      [
                                                        _c("Label", {
                                                          attrs: {
                                                            characteristic:
                                                              item.schoolType
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            : [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "career-item-title"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getJobTitle(item)
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.title &&
                                                item.title !==
                                                  _vm.getJobTitle(item)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "career-item-subtitle"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(item.title) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "career-item-infos"
                                            },
                                            [
                                              _vm.education
                                                ? _c("InfosEducation", {
                                                    attrs: { education: item }
                                                  })
                                                : _c("InfosJob", {
                                                    attrs: { job: item }
                                                  })
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.editItem(item)
                                      }
                                    }
                                  },
                                  [_c("Icon", { attrs: { icon: "pencil" } })],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.$emit("removeItem", item)
                                      }
                                    }
                                  },
                                  [_c("Icon", { attrs: { icon: "bin" } })],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  })
                ],
            _vm._v(" "),
            _c("div", { staticClass: "my-3" }, [
              !_vm.education ? _c("div") : _vm._e(),
              _vm._v(" "),
              _vm.section
                ? _c(
                    "div",
                    [
                      _c(
                        "FormGroup",
                        { attrs: { label: _vm.furtherTitle } },
                        [
                          _c("RadioGroup", {
                            attrs: { options: _vm.furtherOptions },
                            on: { input: _vm.furtherChanged },
                            model: {
                              value: _vm.further,
                              callback: function($$v) {
                                _vm.further = $$v
                              },
                              expression: "further"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }